export const config = {
    defer: true,
    dataDisplayMode: 'widget',
};
export const ONE_MIND_TOKEN_VAULT_KEY = '1MIND_TOKEN';
//# sourceMappingURL=1mind.config.js.map